import React from "react";
import PropTypes from "prop-types";
import styles from "./TrashButton.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

export function TrashButton({ onClick, disabled }) {
  return (
    <div
      className={`${styles.container} ${disabled ? styles.disabled : ""}`}
      onClick={!disabled ? onClick : null}
    >
      <FontAwesomeIcon
        icon={faTrashCan}
        className={styles.trashIcon}
      />
    </div>
  );
}
TrashButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
export default TrashButton;
